exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-caption[data-v-04762e49]{top:10%}.main-login-bg[data-v-04762e49]{background:#fff;height:100vh + 30px;width:100%}.icon-box[data-v-04762e49]{position:relative;margin-top:20px;padding:0 0 0 80px}.icon-left[data-v-04762e49]{display:block;position:absolute;width:64px;height:64px;top:0;left:0;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04762e49","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/auth/SignIn.vue
// module id = 482
// module chunks = 0